// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tooltip_wrapper_3rphu","trigger":"Tooltip_trigger_13zbR","content":"Tooltip_content_aMfiV","text":"Tooltip_text_2Rnnh","btn":"Tooltip_btn_aITmO"};